import { render, staticRenderFns } from "./BTable.vue?vue&type=template&id=4989f1e0&scoped=true"
import script from "./BTable.vue?vue&type=script&lang=js"
export * from "./BTable.vue?vue&type=script&lang=js"
import style0 from "./BTable.vue?vue&type=style&index=0&id=4989f1e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989f1e0",
  null
  
)

export default component.exports